
import { Fragment } from "react";
import Header from "./components/Header";
import Hero from "./components/Hero";
import PainPoints from "./components/PainPoints";
import Features from "./components/Features";
import HowItWorks from "./components/HowItWorks";
import Pricing from "./components/Pricing";
import CallToAction from "./components/CallToAction";
import TrustpilotSection from "./components/TrustpilotSection";
import BuyerSection from "./components/BuyerSection";
import Footer from "./components/Footer";
import PageSEO from "@/components/seo/PageSEO";
import StructuredData from "@/components/seo/StructuredData";

const LandingPage = () => {
  return (
    <div className="min-h-screen flex flex-col bg-godyspo-background text-white">
      <PageSEO
        title="GoDyspo | Real Estate Disposition & Wholesale Deal Management"
        description="The #1 disposition platform for real estate wholesalers and agents. List off-market properties, manage your buyer list, and close deals faster. InvestorLift alternative with 30-day free trial."
        canonical="/seller"
        keywords="real estate disposition, dispo software, wholesale deal software, property disposition platform, wholesale CRM, InvestorLift alternative, off-market property listings, real estate wholesaler software"
      />
      <StructuredData type="WebSite" />
      <Header />
      <div className="max-w-screen-2xl mx-auto">
        <Hero />
        <PainPoints />
        <Features />
        <HowItWorks />
        <Pricing />
        <CallToAction />
        <TrustpilotSection />
        <BuyerSection />
      </div>
      <Footer />
    </div>
  );
};

export default LandingPage;
